export const Icons = [
  { image: "/images/logos/swiftui-logo.svg", title: "Swift UI logo" },
  { image: "/images/logos/react-logo.svg", title: "React logo" },
  { image: "/images/logos/figma-logo.svg", title: "Figma logo" },
  { image: "/images/logos/sketch-logo.svg", title: "Sketch logo" },
  { image: "/images/logos/framer-logo.svg", title: "Framer logo" },
  { image: "/images/logos/webflow-logo.svg", title: "Webflwo logo" },
  { image: "/images/logos/protopie-logo.svg", title: "Protopie logo" },
]

export const PlayerCardData = [
  {
    number: "1",
    title: "Introduction Veu CSS",
    property: "Read",
    description:
      "Veu is a progressive framework for creating user interfaces. veu is not heavy, the frame is simple compared to others. Veu can perfectly cater to any size website. The framework is newly created and is constantly updated. Which makes learning interesting",
    route: "/",
  },
  {
    number: "2",
    title: "Components",
    property: "Read",
    description: "Beautiful UI components, crafted by the creators of Veu CSS",
    route: "/",
  },
  {
    number: "3",
    title: "Resources",
    property: "Read",
    description:
      "We think Veu is an amazing CSS framework, but you need more than just a CSS framework to produce visually awesome work.",
    route: "/",
  },
  {
    number: "4",
    title: "Utility-First",
    property: "Read",
    description:
      "Building complex components from a constrained set of primitive utilities.",
    route: "/",
  },
  {
    number: "5",
    title: "Hover, Focus, & Other States",
    property: "Read",
    description: "Using utilities to style elements on hover, focus, and more.",
    route: "/",
  },
  {
    number: "6",
    title: "Responsive Design",
    property: "Read",
    description:
      "Using responsive utility variants to build adaptive user interfaces.",
    route: "/",
  },
  {
    number: "7",
    title: "Container",
    property: "Read",
    description:
      "A component for fixing an element's width to the current breakpoint.",
    route: "/",
  },
  {
    number: "8",
    title: "Box Sizing",
    property: "Read",
    description:
      "Utilities for controlling how the browser should calculate an element's total size.",
    route: "/",
  },
  {
    number: "9",
    title: "Display",
    property: "Read",
    description:
      "Utilities for controlling the display box type of an element.",
    route: "/",
  },
  {
    number: "10",
    title: "Floats",
    property: "Read",
    description:
      "Utilities for controlling the wrapping of content around an element.",
    route: "/",
  },
  {
    number: "11",
    title: "Clear",
    property: "Read",
    description:
      "Utilities for controlling the wrapping of content around an element.",
    route: "/",
  },
]

export const ComponentData = [
  {
    number: "1",
    title: "Card",
    description:
      "Veu's cards provide a flexible and extensible content container with multiple variants and options.",
    property: "Read",
    route: "/",
  },
  {
    number: "2",
    title: "Alerts",
    description:
      "Provide contextual feedback messages for typical user actions with the handful of available and flexible alert messages.",
    property: "Read",
    route: "/",
  },
  {
    number: "3",
    title: "Buttons",
    description:
      "Use Veu's custom button styles for actions in forms, dialogs, and more with support for multiple sizes, states, and more.",
    property: "Read",
    route: "/",
  },
  {
    number: "4",
    title: "Input group",
    description:
      "Easily extend form controls by adding text, buttons, or button groups on either side of textual inputs, custom selects, and custom file inputs.",
    property: "Read",
    route: "/",
  },
  {
    number: "5",
    title: "Sign-in and Registration",
    description:
      "Provide valuable, actionable feedback to your users with HTML5 form validation, via browser default behaviors or custom styles and JavaScript.",
    property: "Read",
    route: "/",
  },
  {
    number: "6",
    title: "Close button",
    description:
      "A generic close button for dismissing content like modals and alerts.",
    property: "Read",
    route: "/",
  },
  {
    number: "7",
    title: "Badges",
    description:
      "Documentation and examples for badges, our small count and labeling component.",
    property: "Read",
    route: "/",
  },
  {
    number: "8",
    title: "List group",
    description:
      "List groups are a flexible and powerful component for displaying a series of content. Modify and extend them to support just about any content within.",
    property: "Read",
    route: "/",
  },
  {
    number: "9",
    title: "Modal",
    description:
      "Use Veu's JavaScript modal plugin to add dialogs to your site for lightboxes, user notifications, or completely custom content.",
    property: "Read",
    route: "/",
  },
]
